










































































































































































































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import PayModal from './PayModal.vue'

@Component({
  components: { PayModal }
})
export default class PayAgreement extends Vue {
  public visible = false
  @Prop() value!: boolean
  @Watch('value')
  onValChange(val) {
    this.visible = val
  }
  @Emit()
  onCancel() {}
  cancel() {
    this.onCancel()
  }
}
